import { useSelector } from 'react-redux';

import { RootState } from 'store';

const useCountry = () => useSelector((state: RootState) => state.i18n.country);

export default useCountry;
